/*
  ============================================================
  Goods Scene - Quick Add modal content.

  The modal injects the PRODUCT PAGE section (main-product.liquid), so the
  origin badge, short title, dock suffix, compatibility line and availability
  row do not exist in its DOM. Rebuilding them in Liquid would mean editing
  main-product.liquid - the same section the product page renders - so the
  PRODUCT PAGE would change too.

  INSTEAD: the card has already computed every one of these values and passes
  them as data-gs-* attributes on its own <quick-add-modal>. This script drops
  them in once Dawn has injected the content. ONE SOURCE OF TRUTH - no rule is
  duplicated, so the card and the modal cannot drift apart.

  KNOWN PLATFORM LIMIT: Shopify does NOT render APP BLOCKS into an AJAX
  section fetch, so the HulkApps wishlist button cannot appear here at all.
  Confirmed with a probe: the element is absent, not merely unstyled.
  ============================================================
*/
(function () {
  'use strict';

  var FLAG = 'gsQaObserved';

  var ICON = {
    shield:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v5c0 4.6-3 8.4-7 10-4-1.6-7-5.4-7-10V6l7-3z"/><path d="M9 12l2 2 4-4"/></svg>',
    'return':
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 10h11a5 5 0 0 1 0 10h-4"/><path d="M7 6l-4 4 4 4"/></svg>',
    badge:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="9" r="6"/><path d="M9 9l2 2 4-4"/><path d="M8 14l-1 7 5-3 5 3-1-7"/></svg>'
  };

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function trustItem(icon, text) {
    var s = el('span');
    s.innerHTML = ICON[icon];
    s.appendChild(document.createTextNode(text));
    return s;
  }

  // Dawn puts the product URL on the "Choose options" button that opens this
  // modal, so it never needs passing through Liquid.
  function productUrl(modal) {
    var opener = document.querySelector(
      'modal-opener[data-modal="#' + modal.id + '"] [data-product-url]'
    );
    return opener ? opener.getAttribute('data-product-url') : null;
  }

  function build(modal) {
    var title = modal.querySelector('.product__title');
    if (!title) return;

    // Dawn re-injects the whole block on every open, so this flag lives on the
    // injected node and resets by itself. It also stops the MutationObserver
    // from re-entering while we are writing.
    if (title.getAttribute('data-gs-built') === '1') return;
    title.setAttribute('data-gs-built', '1');

    /* ---- quantity moves BELOW the variant picker ----
       main-product.liquid emits .product-form__quantity BEFORE
       variant-selects / variant-radios, but the approved buying flow is
       Variant/KIT -> Quantity -> Add to cart. Reordering the blocks in Liquid
       would change the PRODUCT PAGE, which is out of scope, so the original
       node is moved here instead - Quick Add only.

       An earlier build faked the order in CSS with float: right and paired
       percentage widths. That put the quantity in a second column on the far
       right at every width and was replaced by this move; those rules are gone
       from gs-quick-add.css.

       insertBefore MOVES the node, it does not copy it, so <quantity-input>
       and every listener Dawn bound to it survive intact. Nothing is cloned
       and no handler is re-created.

       compareDocumentPosition is the idempotency guard: once the quantity sits
       AFTER the picker the condition is false, so repeated build() calls from
       the MutationObserver do nothing. No new observer and no new listener are
       added - this rides the existing build lifecycle.

       A product with no variants has no picker; the block is skipped and the
       quantity keeps its original position, which is correct there. */
    var qty = modal.querySelector('.product-form__quantity');
    var picker = modal.querySelector('variant-selects, variant-radios');

    if (
      qty &&
      picker &&
      (qty.compareDocumentPosition(picker) & Node.DOCUMENT_POSITION_FOLLOWING)
    ) {
      picker.parentNode.insertBefore(qty, picker.nextSibling);
    }

    var d = function (k) { return modal.getAttribute('data-gs-' + k); };
    var t = function (k, v) { return window.gsT ? window.gsT('quick_add.' + k, v) : ''; };

    /* ---- short title, matching the card exactly ---- */
    var wanted = d('title');
    if (wanted) {
      var targets = title.querySelectorAll('a, h1');
      if (!targets.length) targets = [title];
      for (var i = 0; i < targets.length; i++) {
        if (targets[i].textContent.trim() !== wanted) targets[i].textContent = wanted;
      }
    }

    /* ---- part origin badge, above the title ---- */
    var origin = d('origin');
    if (origin) {
      var wrap = el('div', 'gs-qa-badges');
      wrap.appendChild(el('span', 'gs-badge ' + (d('origin-class') || ''), origin));
      title.parentNode.insertBefore(wrap, title);
    }

    /* ---- compatibility line + dock suffix, under the title ----
       "Dock" goes at the END, right after the last model. It restores the
       qualifier that sits BEFORE the colon in the full Shopify title and is
       therefore lost from the short name. An icon-chip version was tried and
       rejected - it read as decoration, not as a fitment fact. */
    var meta = el('div', 'gs-qa-meta');
    var isDock = d('dock') === '1';
    var compat = d('compat');

    if (isDock || compat) {
      var line = el('p', 'gs-qa-compat');

      if (compat && isDock) {
        // One string with a [dock] slot, so a language can move the suffix; the slot becomes the span.
        var parts = t('for_models_dock', { models: compat }).split('[dock]');
        for (var p = 0; p < parts.length; p++) {
          if (p > 0) line.appendChild(el('span', 'gs-dock-suffix', t('dock')));
          if (parts[p]) line.appendChild(document.createTextNode(parts[p]));
        }
      } else if (compat) {
        line.appendChild(document.createTextNode(t('for_models', { models: compat })));
      } else if (isDock) {
        line.appendChild(el('span', 'gs-dock-suffix', t('dock')));
      }

      meta.appendChild(line);

      if (compat && d('more') === '1') {
        var more = el('button', 'gs-qa-more', t('and_more'));
        more.type = 'button';
        more.addEventListener('click', function () {
          var open = line.classList.toggle('gs-qa-compat--open');
          more.textContent = open ? t('show_less') : t('and_more');
        });
        meta.appendChild(more);
      }
    }

    var avail = d('avail');
    if (avail) {
      var row = el('div', 'gs-qa-avail gs-availability ' + (d('avail-class') || ''));
      var dot = el('span', 'gs-dot');
      dot.setAttribute('aria-hidden', 'true');
      row.appendChild(dot);
      row.appendChild(el('span', null, avail));
      meta.appendChild(row);
    }

    if (meta.childNodes.length) {
      title.parentNode.insertBefore(meta, title.nextSibling);
    }

    /* ---- footer: trust row + link to the full product page ----
       Appended to the info container rather than inserted before Dawn's
       .product__view-details. An earlier version depended on that element
       existing, so when it was missing on mobile BOTH the trust row and the
       link disappeared together. */
    var container =
      modal.querySelector('.product__info-container') ||
      modal.querySelector('.product__info-wrapper') ||
      title.parentNode;

    if (container && !modal.querySelector('.gs-qa-trust')) {
      var trust = el('div', 'gs-qa-trust');
      trust.appendChild(trustItem('shield', t('secure_checkout')));
      trust.appendChild(trustItem('return', t('returns')));

      // Only a true claim about THIS product. A REPLACEMENT part, or one with
      // no part_origin at all, gets nothing rather than a false badge.
      // Decided on the RAW part_origin value (data-gs-origin-key), never on the translated label.
      var originKey = d('origin-key');
      if (origin && (originKey === 'Original' || originKey === 'OEM')) {
        trust.appendChild(trustItem('badge', t('origin_part', { origin: origin })));
      }

      container.appendChild(trust);
    }

    var existing = modal.querySelector('.product__view-details');
    if (existing) {
      container.appendChild(existing);
    } else {
      var url = productUrl(modal);
      if (url && container && !modal.querySelector('.gs-qa-details')) {
        var a = el('a', 'gs-qa-details', t('view_details'));
        a.href = url;
        a.appendChild(el('span', 'gs-qa-arrow', ' \u2192'));
        container.appendChild(a);
      }
    }
  }

  function watch(modal) {
    if (modal[FLAG]) return;
    modal[FLAG] = true;

    var info = modal.querySelector('.quick-add-modal__content-info');
    if (!info) return;

    new MutationObserver(function () { build(modal); }).observe(info, {
      childList: true,
      subtree: true
    });

    build(modal);
  }

  function scan() {
    var modals = document.querySelectorAll('quick-add-modal[data-gs-title]');
    for (var i = 0; i < modals.length; i++) watch(modals[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', scan);
  window.addEventListener('pageshow', scan);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('modal-opener')) scan();
  }, true);

  if (window.MutationObserver) {
    var grid = document.getElementById('ProductGridContainer');
    if (grid) new MutationObserver(scan).observe(grid, { childList: true, subtree: true });
  }
})();
